import React from "react";
// 1. Import Helmet
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useState, useEffect } from "react";
import config from "../config.json";
import CryptoJS from "crypto-js";

// Define metadata constants for SEO
const PAGE_TITLE = "Steminorder | Navigating the Shipping Sector Globally";
const PAGE_DESCRIPTION = "Steminorder.com is one of the biggest and rapidly growing web sites presenting all necessities for companies or persons related to the shipping sector. Find cargo, vessels, and companies.";
const CANONICAL_URL = "https://www.steminorder.com/";
const OG_IMAGE_URL = "https://www.steminorder.com/images/hero-pattern.png"; // Assuming this is the main visual for sharing

const Home = () => {
  const [concerns, setConcerns] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [vesselTypes, setVesselTypes] = useState([]);
  const [cargoResponse, setCargoResponse] = useState("");
  const [error, setError] = useState([]);

  useEffect(() => {
    var currentDate = new Date();
    var currentMonth = new Date(
      "2024/" + currentDate.getMonth() + "/" + currentDate.getDate()
    );
    document.getElementById("laycanDateStart").valueAsDate = currentMonth;
    document.getElementById("laycanDateEnd").valueAsDate = currentDate;

    document.getElementById("laycanDateStartPosition").valueAsDate =
      currentMonth;
    document.getElementById("laycanDateEndPosition").valueAsDate = currentDate;

    fetch(`${process.env.REACT_APP_API_ENDPOINT}/cargo/entryform`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}), // send empty object if no payload required
    })
      .then(async (res) => {
        if (!res.ok) {
          // Try to parse error response
          let errorData = await res.json().catch(() => ({}));
          setError(errorData.errors || ["Unknown error occurred."]);
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (data) {
          if (data.regions) setRegions(data.regions);
        }
      })
      .catch((err) => {
        setError([err.message || "Network error"]);
      });

    fetch(`${process.env.REACT_APP_API_ENDPOINT}/vessel/detail/entryform`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}), // send empty object if no payload required
    })
      .then(async (res) => {
        if (!res.ok) {
          // Try to parse error response
          let errorData = await res.json().catch(() => ({}));
          setError(errorData.errors || ["Unknown error occurred."]);
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (data) {
          if (data.vesseltypes) setVesselTypes(data.vesseltypes);
          if (data.flags) setCountries(data.flags);
          if (data.concerns) setConcerns(data.concerns);
        }
      })
      .catch((err) => {
        setError([err.message || "Network error"]);
      });
  }, []);

  const handleClickEventCargoSearch = (event) => {
    event.preventDefault();
    const loadingRegionId = event.target.elements.loadingRegionCargo.value;
    const dischargingRegionId =
      event.target.elements.dischargingRegionCargo.value;
    const laycanStartDate = event.target.elements.laycanDateStartCargo.value;
    const laycanEndDate = event.target.elements.laycanDateEndCargo.value;
    const loadingRegionIdArr =
      loadingRegionId !== "-1" ? [parseInt(loadingRegionId)] : [];
    const dischargingRegionIdArr =
      dischargingRegionId !== "-1" ? [parseInt(dischargingRegionId)] : [];
    const filterJson = {
      loadingregionids: loadingRegionIdArr,
      dischargingregionids: dischargingRegionIdArr,
      laycanstartdate: laycanStartDate,
      laycanenddate: laycanEndDate,
      pageindex: 0,
      sortcolumn: null,
    };

    console.log("====================================");
    console.log(filterJson);
    console.log("====================================");

    cargoSearchAPI(filterJson);
  };

  const handleClickEventPositionSearch = (event) => {
    event.preventDefault();
    const vesselNamePosition = event.target.elements.vesselNamePosition.value;
    const vesselTypePosition = event.target.elements.vesselTypePosition.value;
    const vesselRegionPosition =
      event.target.elements.vesselRegionPosition.value;
    const laycanDateStartPosition =
      event.target.elements.laycanDateStartPosition.value;
    const laycanDateEndPosition =
      event.target.elements.laycanDateEndPosition.value;
    const vesselTypePositionArr =
      vesselTypePosition !== "-1" ? [parseInt(vesselTypePosition)] : [];
    const vesselRegionPositionArr =
      vesselRegionPosition !== "-1" ? [parseInt(vesselRegionPosition)] : [];

    const filterJson = {
      vesselname: vesselNamePosition,
      vesseltypeids: vesselTypePositionArr,
      regionids: vesselRegionPositionArr,
      datefrom: laycanDateStartPosition,
      dateto: laycanDateEndPosition,
      pageindex: 0,
      sortcolumn: null,
    };

    positionSearchAPI(filterJson);
  };

  const handleClickEventCompanySearch = (event) => {
    event.preventDefault();
    const companyName = event.target.elements.companyName.value;
    const countriesCompany = event.target.elements.countriesCompany.value;
    const concernsCompany = event.target.elements.concernsCompany.value;
    const cityCompany = event.target.elements.cityCompany.value;
    const countriesCompanyArr =
      countriesCompany !== "-1" ? [parseInt(countriesCompany)] : [];
    const concernsCompanyArr =
      concernsCompany !== "-1" ? [parseInt(concernsCompany)] : [];

    const filterJson = {
      companyname: companyName,
      countryids: countriesCompanyArr,
      concernids: concernsCompanyArr,
      city: cityCompany,
      pageindex: 0,
      sortcolumn: null,
    };

    console.log("====================================");
    console.log(filterJson);
    console.log("====================================");

    companySearchAPI(filterJson);
  };

  const cargoSearchAPI = (filterJson) => {
    let completeURL = config.ROOT_URL + "cargo/cargoes-listing";

    console.log(JSON.stringify(filterJson));
    const key = CryptoJS.PBKDF2("steminorder", "salt", {
      keySize: 256 / 32,
      iterations: 100,
    });
    const iv = CryptoJS.enc.Utf8.parse("steminorder");
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(filterJson), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    });
    console.log("enc @@@", encrypted.ciphertext.toString(CryptoJS.enc.Hex));
    const encText = encrypted.ciphertext.toString(CryptoJS.enc.Hex);

    completeURL = completeURL + "?search=" + encText;
    console.log("====================================");
    console.log(encrypted);
    console.log("====================================");

    console.log("====================================");
    console.log(completeURL);
    console.log("====================================");
    window.location.href = completeURL;
  };

  const positionSearchAPI = (filterJson) => {
    let completeURL =
      config.ROOT_URL + "vessel/position/vesselpositions-listing";

    console.log(JSON.stringify(filterJson));
    const key = CryptoJS.PBKDF2("steminorder", "salt", {
      keySize: 256 / 32,
      iterations: 100,
    });
    const iv = CryptoJS.enc.Utf8.parse("steminorder");
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(filterJson), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    });
    console.log("enc @@@", encrypted.ciphertext.toString(CryptoJS.enc.Hex));
    const encText = encrypted.ciphertext.toString(CryptoJS.enc.Hex);

    completeURL = completeURL + "?search=" + encText;
    console.log("====================================");
    console.log(encrypted);
    console.log("====================================");

    console.log("====================================");
    console.log(completeURL);
    console.log("====================================");
    window.location.href = completeURL;
  };

  const companySearchAPI = (filterJson) => {
    let completeURL = config.ROOT_URL + "company/companies-listing";

    console.log(JSON.stringify(filterJson));
    const key = CryptoJS.PBKDF2("steminorder", "salt", {
      keySize: 256 / 32,
      iterations: 100,
    });
    const iv = CryptoJS.enc.Utf8.parse("steminorder");
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(filterJson), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    });
    console.log("enc @@@", encrypted.ciphertext.toString(CryptoJS.enc.Hex));
    const encText = encrypted.ciphertext.toString(CryptoJS.enc.Hex);

    completeURL = completeURL + "?search=" + encText;
    console.log("====================================");
    console.log(encrypted);
    console.log("====================================");

    console.log("====================================");
    console.log(completeURL);
    console.log("====================================");
    window.location.href = completeURL;
  };

  const faqs = [
    {
      q: "What is StemInOrder.com?",
      a: "Steminorder.com is one of the biggest and rapidly growing web site presents all necessaries for companies or persons related with shipping sector.",
    },
    {
      q: "Who can use StemInOrder.com?",
      a: "Ship owners, charterers, brokers, and logistics professionals who need reliable vessel and cargo information.",
    },
    {
      q: "I have a ship for sale or charter, what do I do?",
      a: "Contact us and submit your ship details; we’ll help you list and promote it to the right audience.",
    },
  ];

  return (
    <>
      {/* ============================================================
        REACT HELMET INTEGRATION 
        ============================================================
      */}
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        
        {/* Canonical URL */}
        <link rel="canonical" href={CANONICAL_URL} />

        {/* Open Graph Tags */}
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:url" content={CANONICAL_URL} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Steminorder" />
        <meta property="og:image" content={OG_IMAGE_URL} /> 
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
        <meta name="twitter:image" content={OG_IMAGE_URL} />
      </Helmet>
      
      <Header />
      <div className="hero bg-hero-pattern bg-center bg-cover px-20 py-36 align-middle h-75">
        <div className="container align-middle justify-center mx-auto">
          <h1 className="font-semibold text-[40px] leading-[100%] tracking-normal text-white py-10 max-w-[600px]">
            We are THE global shipping platform bringing together…
          </h1>
<p className="text-white font-normal text-[24px] leading-[100%] tracking-normal">
  … over <span className="font-bold">90,000 members</span><br />
  … from <span className="font-bold">226 countries</span><br />
<br></br>
  since 1999,<br />
  <br></br>

  boiling down to an average of…<br />
  <br></br>

  <span className="font-bold">… 1000 vessel positions</span><br />
  <span className="font-bold">… 3000 cargo positions</span><br />

  <br></br>

  daily,<br />
<br></br>
  and counting!
</p>

        </div>
      </div>
      
      <div className="bg-header-green">
        <div className="container align-middle justify-center mx-auto py-10 ">
          <nav className="mb-3">
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link active"
                id="nav-cargo-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria="true"
              >
                Cargo Search
              </button>
              <button
                className="nav-link"
                id="nav-position-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-profile"
                type="button"
                role="tab"
                aria-controls="nav-profile"
                aria="false"
              >
                Vessel Position Search
              </button>
              <button
                className="nav-link"
                id="nav-company-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-contact"
                type="button"
                role="tab"
                aria-controls="nav-contact"
                aria="false"
              >
                Company Search
              </button>
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-cargo-tab"
            >
              <form onSubmit={handleClickEventCargoSearch}>
                <div className="row">
                  <div className="col-lg-3 col-sm-12">
                    <div className="form-group">
                      <label
                        className="text-white py-2"
                        for="loadingRegionInput"
                      >
                        Loading Region
                      </label>
                      <select
                        className="form-select form-select-home"
                        name="loadingRegionCargo"
                        id="loadingRegionInput"
                      >
                        <option value={-1}>Search All</option>
                        {regions.map((region) => (
                          <option value={region.id}>{region.value}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-12">
                    <div className="form-group">
                      <label
                        className="text-white py-2"
                        for="dischargingRegionInput"
                      >
                        Discharging Region
                      </label>
                      <select
                        className="form-select form-select-home"
                        name="dischargingRegionCargo"
                        id="dischargingRegionInput"
                      >
                        <option value={-1}>Search All</option>
                        {regions.map((region) => (
                          <option value={region.id}>{region.value}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12">
                    <div className="form-group">
                      <label className="text-white py-2" for="laycanDateStart">
                        Laycan Date Start
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="laycanDateStart"
                        name="laycanDateStartCargo"
                        aria-describedby="emailHelp"
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12">
                    <div className="form-group">
                      <label className="text-white py-2" for="laycanDateEnd">
                        Laycan Date End
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="laycanDateEnd"
                        name="laycanDateEndCargo"
                        aria-describedby="emailHelp"
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12 d-flex">
                    <div className="mb-auto searchButtonContainer">
                      <button className="btn btn-primary-white" type="submit">
                        {" "}
                        <i className="bi bi-search"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <div className="row">
                {/* {cargoResponse.list.map(resp => <p className='text-white'>{resp.cargotype}</p>)} */}
                <p className="text-white">{cargoResponse}</p>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-position-tab"
            >
              <form onSubmit={handleClickEventPositionSearch}>
                <div className="row">
                  <div className="col-lg-2 col-sm-12">
                    <div className="form-group">
                      <label className="text-white py-2" for="vesselNameInput">
                        Vessel Name
                      </label>
                      <input
                        type="text"
                        className="form-control shadow-none search-free-text"
                        name="vesselNamePosition"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12">
                    <div className="form-group">
                      <label className="text-white py-2" for="vesselTypeInput">
                        Vessel Types
                      </label>
                      <select
                        className="form-select form-select-home"
                        name="vesselTypePosition"
                        id="vesselTypeInput"
                      >
                        <option value={-1}>Search All</option>
                        {vesselTypes.map((type) => (
                          <option value={type.id}>{type.value}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12">
                    <div className="form-group">
                      <label
                        className="text-white py-2"
                        for="vesselRegionsInput"
                      >
                        Regions
                      </label>
                      <select
                        className="form-select form-select-home"
                        name="vesselRegionPosition"
                        id="vesselRegionsInput"
                      >
                        <option value={-1}>Search All</option>
                        {regions.map((region) => (
                          <option value={region.id}>{region.value}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12">
                    <div className="form-group">
                      <label
                        className="text-white py-2"
                        for="laycanDateStartPosition"
                      >
                        Laycan Date Start
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="laycanDateStartPosition"
                        name="laycanDateStartPosition"
                        aria-describedby="emailHelp"
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12">
                    <div className="form-group">
                      <label
                        className="text-white py-2"
                        for="laycanDateEndPosition"
                      >
                        Laycan Date End
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="laycanDateEndPosition"
                        name="laycanDateEndPosition"
                        aria-describedby="emailHelp"
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12 d-flex">
                    <div className="mb-auto searchButtonContainer">
                      <button type="submit" className="btn btn-primary-white">
                        {" "}
                        <i className="bi bi-search"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div
              className="tab-pane fade"
              id="nav-contact"
              role="tabpanel"
              aria-labelledby="nav-company-tab"
            >
              <form onSubmit={handleClickEventCompanySearch}>
                <div className="row">
                  <div className="col-lg-3 col-sm-12">
                    <div className="form-group">
                      <label className="text-white py-2" for="companyNameInput">
                        Company Name
                      </label>
                      <input
                        type="text"
                        className="form-control shadow-none search-free-text"
                        name="companyName"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-12">
                    <div className="form-group">
                      <label className="text-white py-2" for="countriesCompany">
                        Countries
                      </label>
                      <select
                        className="form-select form-select-home"
                        name="countriesCompany"
                        id="countriesCompany"
                      >
                        <option value={-1}>Search All</option>
                        {countries.map((country) => (
                          <option value={country.id}>{country.value}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12">
                    <div className="form-group">
                      <label className="text-white py-2" for="concernsCompany">
                        Concerns
                      </label>
                      <select
                        className="form-select form-select-home"
                        name="concernsCompany"
                        id="concernsCompany"
                      >
                        <option value={-1}>Search All</option>
                        {concerns.map((concern) => (
                          <option value={concern.id}>{concern.value}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12">
                    <div className="form-group">
                      <label className="text-white py-2" for="cityCompany">
                        City
                      </label>
                      <input
                        type="text"
                        className="form-control shadow-none search-free-text"
                        name="cityCompany"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-12 d-flex">
                    <div className="mb-auto searchButtonContainer">
                      <button type="submit" className="btn btn-primary-white">
                        {" "}
                        <i className="bi bi-search"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

            {/* <section className="bg-white py-12">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-xl text-gray-700 mb-6">
              We are <strong>THE global shipping platform</strong> bringing together…
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 items-center">
              <div className="p-4">
                <h3 className="text-3xl font-extrabold">90,000+</h3>
                <p className="text-sm text-gray-600">Members</p>
                <p className="text-xs text-gray-500 mt-2">from 226 countries</p>
              </div>

              <div className="p-4">
                <h3 className="text-3xl font-extrabold">Since 1999</h3>
                <p className="text-sm text-gray-600">Serving the industry</p>
              </div>

              <div className="p-4">
                <h3 className="text-3xl font-extrabold">Daily Averages</h3>
                <p className="text-sm text-gray-600">~1,000 vessel positions</p>
                <p className="text-sm text-gray-600">~3,000 cargo positions</p>
              </div>
            </div>

            <p className="text-sm text-gray-500 mt-6">daily, and counting!</p>
          </div>
        </div>
      </section> */}

      {/* <div className="container">
        <div className="d-flex py-5">
          <div className="row py-5">
            <div className="col-lg-6 col-sm-12">
              <h2 className="leading-relaxed text-4xl">
                Just register on-line to gain <br /> access to all our free
                services.
              </h2>
            </div>
            <div className="col-lg-6 col-sm-12">
              <p className="pb-8 text-[#505253] font-[400] text-[16px] leading-[32px] text-md">
                You will be automatically an Economy Class Member. You will be
                able to send 5000+ e-mails. 
               
              </p>
              <a href="/services" className="btn btn-primary border-none">
                Learn More about us
              </a>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container">
        {/* <div className="row">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  className="d-block w-100"
                  src={require("../images/slider-1.webp")}
                  alt="First slide"
                />
              </div>
              <div className="carousel-item">
                <img
                  className="d-block w-100"
                  src={require("../images/slider-2.webp")}
                  alt="Second slide"
                />
              </div>
              <div className="carousel-item">
                <img
                  className="d-block w-100"
                  src={require("../images/slider-2.webp")}
                  alt="Third slide"
                />
              </div>
            </div>
          </div>
        </div> */}
        {/* <div className="row py-24">
        <div className="col-9 px-0">
          <img className='img img-responsive' src={require("../images/slider-1.png")} alt="" />
        </div>
        <div className="col-3 px-0 ">
          <img className='img-fluid h-100 w-auto' src={require("../images/slider-2.png")} alt="" />

        </div>
      </div> */}
      {/* </div> */}
      {/* <div className="container py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-8 lg:gap-x-[96px] items-center">
          <div className="flex flex-col gap-[33px]"> */}
            {/* <h2 className="leading-relaxed">
              We provide the best and quality Legal <br />
              Services
            </h2> */}

            {/* <p className="text-[#505253] font-[400] text-[16px] leading-[32px]">
              Ensure smooth sailing for your cargo shipments with expert legal
              guidance. From contracts to disputes, we've got you covered. Trust
              us to navigate the legal complexities efficiently and effectively.
            </p> */}

            {/* <div className="grid grid-cols-2">
              <div className="border-r lg:border-r-2 border-solid">
                <h4 className="text-4xl font-bold">226+</h4>
                <p className="text-2xl font-light">Countries</p>
              </div>
              <div className="px-[43px]">
                <h4 className="text-4xl font-bold">25+ Years</h4>
                <p className="text-2xl font-light">Experience</p>
              </div>
            </div> */}
{/* 
            <div className="flex justify-left">
              <a
                href="/services"
                className="btn btn-primary w-auto font-[400] text-[16px] leading-[24px]"
              >
                Learn More
              </a>
            </div> */}
          </div>

            {/* <div>
              <img
                className="img img-responsive"
                src={require("../images/home-section-1.webp")}
                alt=""
              />
            </div> */}
        {/* </div>
      </div> */}

      <div className="container py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-8 lg:gap-x-[96px] items-center">
          <div>
            <img
              className="w-full h-auto"
              src={require("../images/home-section-2.webp")}
              alt=""
            />
          </div>

          <div className="p-5">
            <h2 className="leading-relaxed">Streamlined Vessel Solutions</h2>

            <p className="py-10 text-[#505253] font-[400] text-[16px] leading-[32px]">
              Steminorder.com revolutionizes vessel search with a user-friendly
              platform offering real-time data on available vessels worldwide.
              Our advanced search filters help you find the perfect match for
              your cargo, ensuring efficient and cost-effective shipping
              solutions. Trust us to connect you with the right vessel, right on
              time.
            </p>

            <a href="/pricing" className="btn btn-primary">
              Check out our prices
            </a>
          </div>
        </div>
      </div>
      <div className="container py-16 space-y-[36px]">
        <div className="row">
          <h2 className="text-center">Frequently Asked Questions (FAQ)</h2>
          <p className="text-center text-[#505253] font-[400] text-[16px] leading-[32px] pt-[16px]">
            Browse our faq's below, if you can not find the answer you're
            looking for please contact us.
          </p>
        </div>

        <div className="row">
          <div className="accordion" id="accordionPanelsStayOpenExample">
            {faqs.map((item, idx) => {
              const headingId = `faq-heading-${idx}`;
              const collapseId = `faq-collapse-${idx}`;
              const isFirst = idx === 0;

              return (
                <div className="accordion-item" key={collapseId}>
                  <h2 className="accordion-header" id={headingId}>
                    <button
                      className={`accordion-button shadow-none ${
                        isFirst ? "" : "collapsed"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#${collapseId}`}
                      aria-expanded={isFirst}
                      aria-controls={collapseId}
                    >
                      {item.q}
                    </button>
                  </h2>

                  <div
                    id={collapseId}
                    className={`accordion-collapse collapse ${
                      isFirst ? "show" : ""
                    }`}
                    aria-labelledby={headingId}
                    /* keep it "stay open" by NOT setting data-bs-parent */
                  >
                    <div className="accordion-body py-[10px] px-[1.25rem]">
                      <p className="text-[#505253] font-[400] text-[16px] leading-[32px]">
                        {item.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* <div className="row">
          <div className="col-12 text-center">
            <button className="btn btn-primary">Click for more</button>
          </div>
        </div> */}
      </div>

      <Footer />
    </>
  );
};

export default Home;